import React from 'react';
import { useParams } from 'react-router';
import { PeopleCMSLayout } from '../people.cms.layout';
import { PagePath } from '../../../../navigation/navigation.enums';

export function CompanyPeopleCMSPage(): JSX.Element {
  const params = useParams();

  return <PeopleCMSLayout path={PagePath.userManagementPeople} slugs={{ companySlug: params.companySlug! }} type="company" />;
}